<template>
  <a-card :bordered="false">
    <a-form-model :model="ruleForm" :rules="rules" ref="ruleForm" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="AppID" prop="appId">
        <a-input class="input-box" v-model.trim="ruleForm.appId" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="signKey" prop="signKey">
        <a-input class="input-box" v-model.trim="ruleForm.signKey" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="sourceId" prop="sourceId">
        <a-input class="input-box" v-model.trim="ruleForm.sourceId" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="subSourceId(二级来源)" prop="subSourceId">
        <a-input class="input-box" v-model.trim="ruleForm.subSourceId" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="mebId(会员id)" prop="mebId">
        <a-input class="input-box" v-model.trim="ruleForm.mebId" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="roomRateTypeId(协议类型)" prop="roomRateTypeId">
        <a-select class="input-box" v-model="ruleForm.roomRateTypeId" placeholder="请选择">
          <a-select-option :value="29">
            现付
          </a-select-option>
          <a-select-option :value="28">
            预付底价
          </a-select-option>
          <a-select-option :value="41">
            预付卖价
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="Remark(下单备注)" prop="remark">
        <a-input class="input-box" v-model.trim="ruleForm.remark" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 10, offset: 4 }">
        <a-button type="primary" @click="onSave">保存</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import { USER_SHARE_ID } from '@/store/mutation-types'

export default {
  name: 'AccountSettings',
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 8 },
      ruleForm: {
        appId: '',
        mebId: '',
        remark: '',
        roomRateTypeId: '',
        signKey: '',
        sourceId: '',
        subSourceId: ''
      },
      rules: {
        appId: [
          { required: true, message: '请输入appId', trigger: 'blur' }
        ],
        signKey: [
          { required: true, message: '请输入signKey', trigger: 'blur' }
        ],
        sourceId: [
          { required: true, message: '请输入sourceId', trigger: 'blur' }
        ],
        subSourceId: [
          { required: true, message: '请输入subSourceId(二级来源)', trigger: 'blur' }
        ],
        mebId: [
          { required: true, message: '请输入mebId(会员id)', trigger: 'blur' }
        ],
        roomRateTypeId: [
          { required: true, message: '请选择roomRateTypeId(协议类型)', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入Remark(下单备注)', trigger: 'blur' }
        ]
      },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId
    }
  },
  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'AccountSettings', title: '账号设置' },
      { name: 'PriceRules', title: '价格规则' }
    ])
  },
  mounted() {
    this.getYaDuoAccount()
  },
  methods: {
    getYaDuoAccount() {
      this.getHttpServices().getServerApiService().post('yaduo/manage/findYaDuoAccount', ({
        merchantId: this.merchantId,
        platformId: this.platformId
      })).then(res => {
        this.getLogUtils().logWithTag('getYaDuoAccount', res)
        this.ruleForm.appId = res.appId
        this.ruleForm.mebId = res.mebId
        this.ruleForm.remark = res.remark
        this.ruleForm.roomRateTypeId = res.roomRateTypeId
        this.ruleForm.signKey = res.signKey
        this.ruleForm.sourceId = res.sourceId
        this.ruleForm.subSourceId = res.subSourceId
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onSave() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.getHttpServices().getServerApiService().post('yaduo/manage/editYaDuoAccount', ({
        merchantId: this.merchantId,
        platformId: this.platformId,
        appId: this.ruleForm.appId,
        mebId: this.ruleForm.mebId,
        remark: this.ruleForm.remark,
        roomRateTypeId: this.ruleForm.roomRateTypeId,
        signKey: this.ruleForm.signKey,
        sourceId: this.ruleForm.sourceId,
        subSourceId: this.ruleForm.subSourceId
      })).then(res => {
        this.$message.success('保存成功')
        this.getLogUtils().logWithTag('onSave', res)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>

<style scoped>
.input-box {
  width: 300px;
}
</style>